/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.live.viewerCount";

export { $nsid };

/** Current viewer count for a livestream on a particular server. Record keys are streamer_did::server_did by convention. */
type Main = { $type: "place.stream.live.viewerCount";

  /**
   * The DID of the streamer to teleport to.
   */
  "streamer":l.DidString;

  /**
   * The DID of the server to get the view count for.
   */
  "server":l.DidString;

  /**
   * The current view count for the livestream.
   */
  "count":number;

  /**
   * The time the view count was last updated.
   */
  "updatedAt"?:l.DatetimeString };

export type { Main };

/** Current viewer count for a livestream on a particular server. Record keys are streamer_did::server_did by convention. */
const main = /*#__PURE__*/ l.record<"any", Main>("any", $nsid, /*#__PURE__*/ l.object({"streamer":/*#__PURE__*/ l.string({"format":"did"}),"server":/*#__PURE__*/ l.string({"format":"did"}),"count":/*#__PURE__*/ l.integer(),"updatedAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
